<div class="slide">
    <div class="bg-white">

        <!-- Título del cheatsheet -->
        <msc-heading-actions>
            <h2 class="heading">
                {{ sectionContent?.title }}
            </h2>
        </msc-heading-actions>

        <!--Pagina de contenido Etiqueta del tipo de contenido, encima del embed -->
        <span class="hidden text-sm font-normal text-gray-500 mb-1">{{ 'player.cheatsheet.name' | translate }}</span>

        <!-- Contenido Froala (lógica original intacta) -->
        <div class="cheatsheet-content prose max-w-none text-[#22304C] mb-6 [&_img]:rounded-xl [&_img]:overflow-hidden" [froalaView]="cheat.content"></div>

        <!-- Navegación prev/next (lógica original intacta) -->
        <msc-next-prev-btn (isFinished)="activityFinished()" [validate]="true" [doneAt]="sectionContentSession?.doneAt" [loading]="loading"></msc-next-prev-btn>

    </div>
</div>

<!-- Modal pantalla completa (lógica original intacta) -->
<ng-template #modalFullScreen let-modal>
    <div class="modal-header">
        <span></span>
        <button type="button" class="close" aria-label="Close" (click)="modal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="media-holder froala-modal">
            <div [froalaView]="cheat.content"></div>
        </div>
    </div>
</ng-template>

<app-footer [context]="'cheatsheet'" [contextId]="cheat?.id"></app-footer>

<app-timer [timerService]="timerService" (close)="timerInit()"></app-timer>

<style>
    /* El contenido froala arranca con margen superior propio, lo que dejaba el
       label "Página de contenido" separado del contenido y pegado al título.
       Quitamos ese margen para que el contenido suba y quede pegado al label,
       igual que en los demás contenidos (media, card, etc.). */
    msc-cheatsheet .cheatsheet-content > *:first-child {
        margin-top: 0 !important;
    }
</style>
